import React, { useState, useEffect } from 'react';
import { documentTitle } from '../../components/header/documentTitle';
import { backendGetRequest } from '../../helpers/callBackend';
import CircularProgress from '@mui/material/CircularProgress';
import AuthWrapper from './authWrapper';
import Cookies from "js-cookie";


const LoginRedirect = () => {
  const [data, setData] = useState('');

  const tryApiNTimes = (times, delay) => {
    if (!times) return;

    backendGetRequest(
      '/api/user/login-redirect-v2',
      {},
      true,
      {
        'additionalHeaders': {
          'psg-auth-token': Cookies.get("psg_auth_token")
        }
      }
    ).then(response => {
      let newState = { ...{ data: response?.data } };
      newState['data'] = response?.data;
      setData(newState.data);
      let companyInfo = response?.data?.current_company;

      if (!companyInfo.is_active) {
        window.location.href = "/contact-sales";
      }

      let companyName = companyInfo.company_name;
      if (companyName === undefined) {
        companyName = "";
      }
      if (companyName === "") {
        window.location.href = "/contact-sales";
      } else {
        const sortedCompaniesData = [...response?.data?.company_list].sort((a, b) => {
          const nameA = a.company_name.toLowerCase();
          const nameB = b.company_name.toLowerCase();
          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }
          return 0;
        });
        localStorage.setItem('arpariCompanyListData', JSON.stringify(sortedCompaniesData));
        localStorage.setItem('arpariAffiliatedCompany', JSON.stringify({
          company_name: companyName,
          id: companyInfo.id
        }));
        localStorage.setItem('isBankingCustomer', JSON.stringify(companyInfo.is_banking_customer));
        localStorage.setItem('isSoftwareCustomer', JSON.stringify(companyInfo.is_software_customer))
        localStorage.setItem('arpariUserPermission', response?.data?.user_permission);
        localStorage.setItem('bankAccountPurposes', JSON.stringify(companyInfo.bank_account_purposes));
        let defaultDashboardType = JSON.stringify(companyInfo.dashboard_type);
        if (!companyInfo.is_active) {
          window.location.href = "/contact-sales";
        }
        localStorage.setItem('arpari_dashboard_type', defaultDashboardType);
          

        // clear mercoa values if they are set when moving to new dashboard
        localStorage.removeItem('mercoa_entity_id');
        localStorage.removeItem('mercoa_token');

        window.location.href = "/home";
      }
    }).catch(error => {
      setTimeout(() => {
        tryApiNTimes(times - 1, delay);
      }, delay);
    });
  };

  useEffect(() => {
    documentTitle();
    localStorage.clear();
    tryApiNTimes(20, 3000);
  }, []);

  return (
    <AuthWrapper style={{ width: '100%', height: '100vh' }}>
      <CircularProgress />
    </AuthWrapper>
  );
};

export default LoginRedirect;
